import { Link } from "react-router-dom";
import MediaCard from "@/components/feature/MediaCard";
import type { Media } from "@/utils/media";

interface ContentSectionProps {
  title: string;
  subtitle: string;
  icon: string;
  moreTo: string;
  items: Media[];
}

export default function ContentSection({
  title,
  subtitle,
  icon,
  moreTo,
  items,
}: ContentSectionProps) {
  return (
    <section>
      <div className="mb-5 flex items-end justify-between gap-4">
        <div>
          <h2 className="flex items-center gap-2 font-heading text-xl font-bold text-foreground-950 md:text-2xl">
            <i className={`${icon} text-primary-500`}></i>
            {title}
          </h2>
          <p className="mt-1 text-sm text-foreground-500">{subtitle}</p>
        </div>
        <Link
          to={moreTo}
          className="inline-flex shrink-0 items-center gap-1 whitespace-nowrap text-sm text-primary-600 transition-colors hover:text-primary-700"
        >
          查看更多
          <i className="ri-arrow-right-s-line"></i>
        </Link>
      </div>
      <div className="grid grid-cols-2 gap-3 md:gap-4 sm:grid-cols-3">
        {items.map((media) => (
          <MediaCard key={media.id} media={media} />
        ))}
      </div>
    </section>
  );
}